import { useEffect, useRef } from 'react';
import { isTelegram } from '../services/telegram';
import { syncTelegramOverlay } from '../services/telegramBackStack';

/**
 * Показывает Telegram BackButton, пока открыт оверлей; по Back — onClose.
 */
export function useTelegramOverlayBack(id, isOpen, onClose, zIndex = 0) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!isTelegram()) return undefined;
    syncTelegramOverlay(id, isOpen, () => onCloseRef.current?.(), zIndex);
    return () => syncTelegramOverlay(id, false, () => onCloseRef.current?.(), zIndex);
  }, [id, isOpen, zIndex]);
}
